import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { deleteReq, formatAxiosErrorMessage, get, putOrThrow } from "../../../../_api";
import PageForm, { IPageFormValues } from "../PageForm/PageForm";

const EditPage: React.FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const [page, setPage] = useState<(IPageFormValues & { _id: string }) | undefined>();
  const [submitError, setSubmitError] = useState<string | null>(null);

  useEffect(() => {
    get(`dynamic-pages/${id}`).then((res) => setPage(res));
  }, [id]);

  const onDelete = async () => {
    const conf = window.confirm("Czy na pewno chcesz usunąć tę stronę? Tej operacji nie można cofnąć.");
    if (conf) {
      await deleteReq(`dynamic-pages/${id}`);
      history.push("/pages");
    }
  };

  return (
    <Container size="md" py="xl" pb={250}>
      <Stack gap="lg">
        <Title order={1}>Edytuj stronę</Title>
        {submitError && (
          <Alert
            color="red"
            variant="filled"
            title="Nie zapisano zmian"
            withCloseButton
            onClose={() => setSubmitError(null)}
            style={{ position: "sticky", top: 0, zIndex: 200 }}
          >
            <Text size="sm" c="white" style={{ whiteSpace: "pre-wrap" }}>
              {submitError}
            </Text>
          </Alert>
        )}
        <PageForm
          page={page}
          onSubmit={async (values) => {
            setSubmitError(null);
            try {
              const res = await putOrThrow(`dynamic-pages/${id}`, values);
              if (res !== undefined) history.push("/pages");
            } catch (e) {
              setSubmitError(formatAxiosErrorMessage(e));
            }
          }}
        />
        <Group
          justify="flex-end"
          mt="xl"
          pt="lg"
          style={{ borderTop: "1px solid var(--mantine-color-gray-3)" }}
        >
          <Button variant="light" color="red" size="sm" radius="md" onClick={onDelete}>
            Usuń stronę
          </Button>
        </Group>
      </Stack>
    </Container>
  );
};

export default EditPage;
